<template>
  <div>
    <button class="d-md-none message-header" @click="closeModal">
      <i class="icon-arrow-back mr-2" />
      <span>{{ trainerName }}</span>
    </button>
    <div class="write-to-trainer">
      <p class="d-md-none secondary-header">
        {{ $t('common.message_to_coach') }}
      </p>
      <ValidationObserver ref="observer" slim>
        <Input
          v-model="senderName"
          name="Name"
          class="input-wrapper"
          :desc="$t('common.your_name')"
          rules="required|alpha_num"
          :placeholder="$t('placeholder.enter_your_name')"
          :is-validate="true"
        />
        <Input
          ref="phoneInput"
          v-model="phoneNumber"
          name="Phone"
          class="phone-input input-wrapper"
          :desc="$t('common.your_phone_number')"
          rules="required"
          :is-validate="true"
          :mask="phoneMask.mask"
          type="phone"
          :prefix-content="`+${phoneMask.prefix}`"
          :is-prefix-active="isActive"
          :placeholder="phoneMask.placeholder"
          clearable
          @focused="handlePhoneInput"
          @click.native="handlePhoneInput"
        />
        <Input
          v-model="mail"
          name="Your email"
          class="input-wrapper"
          :desc="$t('common.your_email')"
          :placeholder="$t('placeholder.enter_mail_for_feedback_from_coach')"
          rules="required|email"
          type="email"
          :is-validate="true"
          clearable
        />
        <Input
          v-model="message"
          name="Message"
          class="input-wrapper textarea-input"
          :desc="$t('common.message_to_coach')"
          :placeholder="
            $t('placeholder.ask_question_or_specify_training_details')
          "
          rules="required|min:15"
          :is-validate="true"
          type="textarea"
          draggable="false"
        />
        <el-checkbox v-model="checked">
          {{ $t('common.send_message_copy_to_email') }}
        </el-checkbox>
        <button
          class="button accent-button fz-18 mt-3"
          @click="clickSendMessage"
        >
          <vue-loaders v-if="loading" name="ball-clip-rotate" scale="0.7" />
          <span v-else>{{ $t('common.send_message') }}</span>
        </button>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { ValidationObserver } from 'vee-validate'
import Input from '~/components/Common/Input'

export default {
  name: 'WriteToTrainer',
  components: {
    Input,
    ValidationObserver
  },
  props: {
    trainerName: {
      type: String,
      default: ''
    },
    trainerId: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
    checked: false,
    isActive: false,
    senderName: null,
    phoneNumber: null,
    mail: null,
    message: null,
    loading: false
  }),
  computed: {
    ...mapGetters({
      phoneMask: 'user/getMask'
    }),
    parsePhoneNumber() {
      return +`${this.phoneMask.prefix}${this.phoneNumber.replace(/-/g, '')}`
    }
  },
  methods: {
    closeModal() {
      this.$emit('clicked')
    },
    handlePhoneInput() {
      this.isActive = true
    },
    resetFields() {
      this.senderName = this.phoneNumber = this.mail = this.message = null
      this.checked = false
    },

    async clickSendMessage() {
      const isValidate = await this.$refs.observer.validate()
      if (!isValidate) return
      this.loading = true

      try {
        await this.$api.PublicApi.sendTrainerMessage({
          trainer_id: this.trainerId,
          name: this.senderName,
          email: this.mail,
          text: this.message,
          mobilephone: this.parsePhoneNumber,
          sendcopy: this.checked
        })
        this.loading = false

        await Promise.all([
          this.closeModal(),
          this.resetFields(),
          this.$refs.observer.reset()
        ])
        setTimeout(() => {
          this.$bus.$emit('success', 'message-sent')
        }, 500)
      } catch (e) {
        //  eslint-disable-next-line
      console.log(e)
        this.$bus.$emit('error', 'unknown-error')
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '~assets/css/variables';
.write-to-trainer {
  position: relative;
  padding: 15px;
  /*width: 480px;*/
  background-color: white;
}
.modal-title {
  font-size: 22px;
  text-align: center;
}
.close-button {
  position: absolute;
  top: 15px;
  right: 15px;
}
.message-header {
  width: 100%;
  padding: 15px;
  margin-bottom: 6px;
  box-shadow: 0 0 5.8px 0.2px rgba(0, 0, 0, 0.12);
  text-align: left;
  font-size: 16px;
  color: $gray;
}
.secondary-header {
  padding: 5px 0 20px 0;
  font-size: 16px;
  color: black;
}

.input-wrapper {
  position: relative;
  margin-bottom: 25px;

  &.textarea-input {
    margin-bottom: 18px;
  }
}

@media (min-width: 768px) {
  .write-to-trainer {
    padding: 0 40px;
    border-radius: 7px;
  }

  .accent-button {
    margin: 20px 0 !important;
  }
}
@media (min-width: 992px) {
  .secondary-header {
    font-size: 22px;
  }
}
</style>
